<template>
  <el-card style="height: 86vh">
    <el-table :data="tableData" border
              style="width: 100%;margin-bottom: 20px;margin-top: 20px;height: 70vh">
      <el-table-column prop="fileName" label="文件名称" align="center" min-width="180px"/>
      <el-table-column prop="time" label="下载时间" align="center"/>
      <el-table-column prop="opName" label="下载人" align="center"/>
<!--      <el-table-column prop="monthData" label="数据时间" align="center"/>-->
      <el-table-column prop="status" label="状态" align="center">
        <template v-slot="scope">
          <el-tag v-if="scope.row.status === 0" type="success">下载中</el-tag>
          <el-tag v-if="scope.row.status === 1" type="success">下载成功</el-tag>
          <el-tag v-if="scope.row.status === 2" type="danger">生成失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="fileAddr" label="操作" align="center">
        <template v-slot="scope">
          <el-button type="primary" @click="handlerDownLoad(scope.row.fileAddr)" :disabled="scope.row.status !== 1">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="height: 5vh"
    >
    </el-pagination>
  </el-card>
</template>

<script setup>
import { ref } from 'vue'
import { getAll } from '@/api/down-load'
import axios from 'axios'

const tableData = ref([])
const total = ref(0)
const page = ref(1)
const size = ref(20)

const getAllData = async () => {
  const result = await getAll({
    page: page.value,
    size: size.value
  })
  tableData.value = result.list
  total.value = result.total
}

getAllData()

const handlerDownLoad = (url) => {
  downLoadFile(url)
}

const downLoadFile = async (url) => {
  const response = await axios.get(url, { responseType: 'blob' })
  const pdfUrl = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  const lastPart = url.split('/').pop()
  link.href = pdfUrl
  link.setAttribute('download', lastPart)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

/**
 * size 改变触发
 */
const handleSizeChange = async currentSize => {
  size.value = currentSize
  await getAllData()

}
/**
 * 页码改变触发
 */
const handleCurrentChange = async currentPage => {
  page.value = currentPage
  await getAllData()
}
</script>
